<template>
  <div class="seloHeader" v-if="isSala && visualizarLogo">
    <div
      class="tituloSelo"
      style="cursor: pointer"
      @click="$router.push('/cidade')"
    >
      Selo Sebrae de Referência em Atendimento
    </div>
    <div
      class="medalhas"
      style="cursor: pointer"
      @click="$router.push('/cidade')"
    >
      <img
        src="https://slide1-images.s3.amazonaws.com/public/selo-medalha/seloMedalhaBronze.png"
      />
      <img
        src="https://slide1-images.s3.amazonaws.com/public/selo-medalha/seloMedalhaPrata.png"
      />
      <img
        src="https://slide1-images.s3.amazonaws.com/public/selo-medalha/seloMedalhaOuro.png"
      />
      <img
        src="https://slide1-images.s3.amazonaws.com/public/selo-medalha/seloMedalhaDiamante.png"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["isSala", "isFullAdmin", "groupsConfig", "config"]),
  },
  watch: {
    groupsConfig: {
      handler(val, oldVal) {
        this.visualizarLogo =
          this.isFullAdmin ||
          (this.groupsConfig &&
            this.config &&
            this.groupsConfig.visualizarLogo &&
            this.config.visualizarLogo);
      },
      deep: true,
    },
  },
  data() {
    return {
      visualizarLogo: false,
    };
  },
  mounted() {
    this.visualizarLogo =
      this.isFullAdmin ||
      (this.groupsConfig &&
        this.config &&
        this.groupsConfig.visualizarLogo &&
        this.config.visualizarLogo);
  },
};
</script>

<style lang="scss" scoped>
@import "@/variables.scss";
.seloHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.tituloSelo {
  color: $cor-selo-texto;
  font-weight: bold;
}
.medalhas {
  display: flex;
  align-items: center;
  img {
    width: 90px;
  }
}
</style>
